import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { GET_RESOLVED_SIGNICANT_DEFICIENCIES } from "../../../queries/archiveQrys/secureQrys/enfDashboardQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const colors = ["#a40606", "#108c4f", "#d2b307"];

const ResolvedSignificantDeficiencies = () => {
  const { loading, error, data } = useQuery(GET_RESOLVED_SIGNICANT_DEFICIENCIES);
  if (loading)
    return (
      <>
        <h3>Resolved Significant Deficiencies</h3>
        <SkeletonLoader width='100%' />
      </>
    );

  if (error) return <ErrorHandler error={error} />;

  if (!data)
    return (
      <>
        <h3>Resolved Significant Deficiencies</h3>
        <span>No Data Returned</span>
      </>
    );

  const RADIAN = Math.PI / 180;
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.05;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill='black' textAnchor={x > cx ? "start" : "end"} dominantBaseline='central'>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Resolved Significant Deficiencies</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='resolvedDefLegend'>
          <Legend
            wrapperStyle={{ position: "relative" }}
            payload={data.getResolvedWithoutEnforcementCounts.map((item, index) => ({
              id: item.name,
              value: `${item.name}: ${item.value}`,
              color: colors[index % colors.length]
            }))}
            iconSize={0}
            verticalAlign='top'
            align={"left"}
            style={{ position: "relative" }}
          />
        </Col>
      </Row>
      <Row>
        <Col cypressid='resolvedDefPieChart'>
          <PieChart width={375} height={325}>
            <Pie
              data={data.getResolvedWithoutEnforcementCounts}
              cx='55%'
              cy='60%'
              labelLine={false}
              label={renderCustomLabel}
              dataKey='value'
            >
              {data.getResolvedWithoutEnforcementCounts.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
          </PieChart>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ResolvedSignificantDeficiencies;
